export default __webpack_public_path__ + "7410e3d821a43475ffa32a25fa643a61.svg";